"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function yearFact(dataset, name, additionalForeignKeys) {
    let def = {
        name,
        tableType: 'fact',
        grain: [
            dataset + '::key',
            'year::key',
        ],
        tableGrain: [
            '!' + dataset,
            'year_key',
        ],
        foreignKeys: [
            dataset + '::key'
        ]
    };
    if (additionalForeignKeys)
        def.foreignKeys.push(...additionalForeignKeys);
    return def;
}
const patientPanelMSAAgeBandRanked = yearFact('cbsa', 'patient-panel-msa-age-band-ranked');
const patientPanelMSAHCPCSRanked = yearFact('cbsa', 'patient-panel-msa-hcpcs-ranked');
const patientPanelMSAICDRanked = yearFact('cbsa', 'patient-panel-msa-icd-ranked');
const patientPanelMSAMRLineRanked = yearFact('cbsa', 'patient-panel-msa-mr-line-ranked');
const patientPanelMSAPOSRanked = yearFact('cbsa', 'patient-panel-msa-pos-ranked');
const patientPanelMSASummary = yearFact('cbsa', 'patient-panel-msa-summary');
const patientPanelProviderGroupAgeBandRanked = yearFact('provider-group', 'patient-panel-provider-group-age-band-ranked');
const patientPanelProviderGroupHCPCSRanked = yearFact('provider-group', 'patient-panel-provider-group-hcpcs-ranked');
const patientPanelProviderGroupICDRanked = yearFact('provider-group', 'patient-panel-provider-group-icd-ranked');
const patientPanelProviderGroupMRLineRanked = yearFact('provider-group', 'patient-panel-provider-group-mr-line-ranked');
const patientPanelProviderGroupPOSRanked = yearFact('provider-group', 'patient-panel-provider-group-pos-ranked');
const patientPanelProviderGroupSpecialtyRanked = yearFact('provider-group', 'patient-panel-provider-group-specialty-ranked');
const patientPanelProviderGroupSummary = yearFact('provider-group', 'patient-panel-provider-group-summary');
const patientPanelProviderAgeBandRanked = yearFact('provider', 'patient-panel-provider-age-band-ranked');
const patientPanelProviderHCPCSRanked = yearFact('provider', 'patient-panel-provider-hcpcs-ranked');
const patientPanelProviderICDRanked = yearFact('provider', 'patient-panel-provider-icd-ranked');
const patientPanelProviderMRLineRanked = yearFact('provider', 'patient-panel-provider-mr-line-ranked');
const patientPanelProviderPOSRanked = yearFact('provider', 'patient-panel-provider-pos-ranked');
const patientPanelProviderSummary = yearFact('provider', 'patient-panel-provider-summary');
exports.default = [
    patientPanelMSAAgeBandRanked,
    patientPanelMSAHCPCSRanked,
    patientPanelMSAICDRanked,
    patientPanelMSAMRLineRanked,
    patientPanelMSAPOSRanked,
    patientPanelMSASummary,
    patientPanelProviderGroupAgeBandRanked,
    patientPanelProviderGroupHCPCSRanked,
    patientPanelProviderGroupICDRanked,
    patientPanelProviderGroupMRLineRanked,
    patientPanelProviderGroupPOSRanked,
    patientPanelProviderGroupSpecialtyRanked,
    patientPanelProviderGroupSummary,
    patientPanelProviderAgeBandRanked,
    patientPanelProviderHCPCSRanked,
    patientPanelProviderICDRanked,
    patientPanelProviderMRLineRanked,
    patientPanelProviderPOSRanked,
    patientPanelProviderSummary
];
